export default {
    grading: {
        title: 'Grading',
        limitationInfo: "TODAY'S GRADING LIMIT",
        tabs: {
            submit: 'Submit',
            pending: 'Pending',
            completed: 'Completed'
        },
        nextRun: 'Next run',
        credit: 'Credits',
        card: 'Card',
        price: 'Price',
        duration: 'Duration',
        selectionInfo: 'Selection: {count} / {limit}',
        total: 'Total',
        submit: 'Submit',
        infoTitle: 'Information',
        infoPoint1: 'Grading costs the base worth of the card rarity.',
        infoPoint2: 'You can submit up to 20 cards per day.',
        infoPoint3: 'Cards are returned graded at 8am the next day.',
        infoPoint4: 'The grade increases or decreases your card value by a percentage.',
        completesAt: 'Completes at',
        noPending: 'No pending submissions',
        gradedAt: 'Graded at',
        noCompleted: 'No completed gradings',
        selectCards: 'Select cards',
        cancel: 'Cancel',
        confirmSelection: 'Confirm selection',
        basePrice: 'Base price',
        gradedPrice: 'Graded price',
        finishNowFor: 'Finish now for {price}',
        finishNowToken: 'Finish now (Skip Token)'
    },
    dashboard: {
        welcome: 'Welcome',
        pages: {
            shop: 'Shop',
            marketplace: 'Trading',
            boosters: 'Packs',
            cards: 'Cards',
            collections: 'Collect',
            decks: 'Decks',
            trading: 'Trading',
            social: 'Social',
            gallery: 'Gallery',
            quiz: 'Quiz',
            pokewordle: 'Wordle',
            casino: 'Casino',
            search: 'Search',
            settings: 'Settings',
            administration: 'Admin',
            grading: 'Grading',
        },
        rows: {
            shopping: 'Shopping',
            mystuff: 'My Stuff',
            discover: 'Discover',
            social: 'Social',
            games: 'Games',
            other: 'Other',
        }
    },
    boosters: {
        title: 'Boosters',
        empty: "You don't have any booster-packs",
        buySome: 'Buy some in the shop!',
        currentlyOpening: 'Opening currently in progress',
        bulkInfo: 'Complete {count} set collections to unlock this bulk opener, you have {have} collections completed',
        auto: 'Auto',
        skip: 'Skip',
        stop: 'Stop',
        cardsLeft: 'cards left',
        postedBooster: 'Pulled booster has been posted',
        share: 'Share',
        close: 'Close',
        pulledCards: 'Pulled cards',
    },
    gallery: {
        title: 'Gallery',
        cards: 'cards',
        secrets: 'secrets',
        back: 'back to list',
        highlight: 'Highlight owned cards',
        search: 'Search',
        types: {
            pokemon: 'Pokémon',
            trainer: 'Trainer',
            energy: 'Energy',
            illustration: 'Illustration',
        },
        boosters: 'Boosters',
        products: 'Products',
    },
    collections: {
        title: 'Collections',
        tabs: {
            sets: 'Sets',
            custom: 'Custom'
        },
        bySet: 'by Set',
        create: 'Create new collection',
        createButton: 'Create',
        notifications: {
            created: 'Created collection "{name}"!',
            defineName: 'Please define a name for your new collection',
        },
        collection: 'Collection',
        description: 'Description',
        value: 'Collection value',
        back: 'Back to collections',
        backProfile: 'Back to profile',
        empty: 'This collection does not contain any cards',
        info: 'Collection Card Info',
        sortBy: 'Sort by',
        sort: 'Sort descending',
        public: 'Public collection (shown in your profile)',
        allowDuplicates: 'Allow duplicates in this collection',
        update: 'Update collection',
        updated: 'Updated collection details',
        dissolve: 'Do you really want to dissolve this collection?',
        deleteEmpty: 'Do you really want to delete this empty collection?',
        legendCards: 'LEGEND CARDS',
        vUnionCards: 'V-UNION CARDS',
        cardName: 'Card name',
        cardAdded: 'Card added at',
        settings: 'Collection settings',
        sortFields: {
            date: 'Date added',
            release: 'Release',
            name: 'Name',
            number: 'Card #',
            pokeDex: 'PokeDex #',
        },
        dissolveButton: 'Dissolve collection',
        deleteButton: 'Delete collection',
    },
    cardInfo: {
        name: 'Name',
        set: 'Set',
        series: 'Series',
        artist: 'Artist',
        rarity: 'Rarity',
        type: 'Type',
        weakness: 'Weakness',
        resistance: 'Resistance',
        id: 'Card ID',
        showOn: 'Show on',
        price: 'Your price',
        value: 'Value',
        inCollection: 'In Collection',
        yes: 'Yes',
        no: 'No',
        created: 'Created at',
        addWishlist: 'I want this',
        removeWishlist: 'Remove from wishlist',
        sell: 'Sell for',
        sellX: 'Sell {amount} for',
        share: 'Share',
        shareTitle: '{title} on Dipocaco',
        shareMessage: 'Found a nice card from {set}!',
        copiedID: 'ID copied to clipboard',
        removeFromCollection: 'Remove from collection',
        removeAllFromCollection: 'Remove all from collection',
        setCollectionCover: 'Set as collection cover',
    },
    shop: {
        title: 'Shop',
        limitationInfo: 'OF TODAYS BOOSTER PURCHASE LIMIT',
        limitReached: 'LIMIT REACHED',
        refreshesInfo: 'Refreshes',
        wait: 'wait',
        tabs: {
            specials: 'Specials',
            sets: 'by Set',
            decks: 'Decks',
        },
        headings: {
            collections: 'Collections',
            blisters: 'Blisters',
            tins: 'Tins',
            prepareToFight: 'Prepare to fight!',
        },
        items: {
            single: 'Single booster pack',
            single4: 'Single 4 card booster pack',
            single5: 'Single 5 card booster pack',
            single6: 'Single 6 card booster pack',
            single7: 'Single 7 card booster pack',
            single20: 'Single 20 card booster pack',
            single25: 'Single 25 card booster pack',
            bundle: 'Bundle of 6 booster packs',
            etb: 'Box with 9 booster packs',
            etbWithPromo: 'Box with 9 booster packs and the promo card "{promo}"',
            display: 'Display with 36 booster packs',
            blisterWithOne: 'Blister with one booster pack',
            blisterWithOneAndPromo: 'Blister with one booster pack and the promo card "{promo}"',
            blisterWithOneAndXPromo: 'Blister with one booster pack and {promoCount} promo cards',
            blisterWithTwo: 'Blister with two booster packs',
            blisterWithTwoAndPromo: 'Blister with two booster packs and the promo card "{promo}"',
            blisterWithTwoAndXPromo: 'Blister with two booster packs and {promoCount} promo cards',
            blisterWithThree: 'Blister with three booster packs',
            blisterWithThreeAndPromo: 'Blister with three booster packs and the promo card "{promo}"',
            blisterWithThreeAndXPromo: 'Blister with three booster packs and {promoCount} promo cards',
            mixedAndPromo: '{boosterCount} booster packs and the promo card "{promo}"',
            mixedAndXPromo: '{boosterCount} booster packs and {promoCount} promo cards',
            mixedBoosterOnly: '{type} with {boosterCount} booster packs',
            ultraPremium: 'Ultra premium collection including {boosterCount} booster packs and {promoCount} promo cards',
        },
        owned: 'OWNED',
        notEnoughCredits: "You don't have enough credits for this purchase",
        cooldownActive: 'Cooldown Active',
        addedToInventory: 'Item(s) has been added to your inventory',
        deckAlreadyOwned: 'You already own this deck',
    },
    marketplace: {
        title: 'Marketplace',
        tabs: {
            browse: 'Browse',
            yours: 'Yours',
            create: 'Create',
        },
        currentOffers: 'Current community offers',
        noOffers: 'There are no offers at the moment',
        onlyUnowned: 'Only show unowned',
        from: 'From',
        search: 'Search',
        my: 'My offers',
        noActiveOffers: "You don't have any active offers",
        cardInfo: {
            name: 'Name',
            set: 'Set',
            series: 'Series',
            artist: 'Artist',
            rarity: 'Rarity',
            type: 'Type',
            weakness: 'Weakness',
            resistance: 'Resistance',
            id: 'Card ID',
            showOn: 'Show on',
            price: 'Your price',
            value: 'Value',
            inCollection: 'In Collection',
            yes: 'Yes',
            no: 'No',
            created: 'Created at',
            delete: 'Delete offer',
            buy: 'Buy for'
        },
        create: 'Create a new offer',
        noCards: "You don't have any lose cards at the moment",
        choose: 'Choose a card to sell it to other users in the marketplace',
        info: 'While this card is available on the marketplace, it\'s removed from your card inventory. Marketplace offers will expire after two weeks.',
        offer: 'Offer card on marketplace',
        cancel: 'Cancel',
        createOffer: 'Create marketplace offer',
        notifications: {
            added: 'Card added to marketplace',
            refreshed: 'Refreshed',
            deleted: 'Offer has been deleted',
            purchaseSuccessful: 'Purchase successful'
        },
        back: 'Back to Marketplace',
        refreshOffers: 'Refresh offers',
        price: 'Price',
        free: 'FREE',
        buy: 'Buy',
        get: 'Get',
        noOffersCard: 'There are currently no offers available for this card'
    },
    myCards: {
        heading: 'My cards',
        sellDuplicates: 'Sell duplicates',
        sellingDuplicates: 'Collecting duplicates ...',
        storeNew: 'Collect cards',
        storingNew: 'Storing new Cards in collection ...',
        clear: 'Clear Selection',
        all: 'Select all',
        sellSelected: 'Sell selected',
        putInCollection: 'To collection',
        sellingSelected: 'Selling selected cards ...',
        filter: {
            heading: 'Search / Sort / Filter',
            search: 'Search ...',
            sortBy: 'Sort by',
            sortPulldate: 'Pull-date',
            sortName: 'Name',
            sortDex: 'Pokédex-Number',
            sortType: 'Type',
            sortSupertype: 'Supertype',
            sortRarity: 'Rarity',
            sortSet: 'Set',
            sortArtwork: 'Artwork Artist',
            sortQuantity: 'Quantity',
            sortRelease: 'Release',
            sortPrice: 'Price',
            filters: 'FILTERS',
            noFilter: 'No filter',
            category: 'Category',
            catPokemon: 'Pokémon',
            catTrainer: 'Trainer',
            catEnergy: 'Energy',
            type: 'Type',
            rarity: 'Rarity',
            set: 'Set',
        },
        collectionModal: {
            selectCollection: 'Select collection',
            moveCards: 'Move cards to collection ... ',
        },
        marketplaceDialog: {
            putOnMarketplace: 'Put cards on Marketplace',
            puttingOnMarketplace: 'Putting cards on Marketplace ... ',
            priceMultiplicator: 'Price multiplicator',
            description: 'Please set the price multiplicator that is being applied to all cardprices',
            confirm: 'Confirm',
            freeWarning: 'WARNING: With this multiplicator the cards will be free!',
        },
        hint: 'Long press / right click to select cards',
        showingFiltered: 'No cards matching filter | Showing {n} card matching your filter. | Showing {n} cards matching your filter.',
        empty: 'Pretty empty in here. Open some booster-packs!',
        selectCards: 'Select cards',
        stopSelectingCards: 'Stop selecting',
    },
    quiz: {
        info: 'Take part in a quiz about Pokémon and earn up to 100 <img src="/assets/dipocaco/currency_x64.png" alt="" class="currency-icon" style="height: 1.5em"> per game!',
        info2: 'Every round consists of {count} randomly generated questions.',
        start: 'Start new quiz',
        progress: 'Question {done} from {from}',
        leaderboard: {
            name: 'Leaderboard',
            correct: 'Correct',
            questions: 'Questions',
        },
        answers: {
            correct: 'The correct answer was {answer}'
        },
        solution: {
            correct: 'Correct!',
            wrong: 'Wrong!',
            weight: "{name} weights {answer}kg",
            height: "{name}'s height is {answer}m",
            types: "{name}'s type is",
            generation: "{name} belongs to generation {generation}",
        },
        questions: {
            name: "Who's that Pokémon?",
            legendary: "Who's the legendary Pokémon?",
            baby: "Who's the baby Pokémon?",
            weight: "How heavy is {name}?",
            types: "What's the type of {name}?",
            height: "How large is {name}?",
            generation: "What generation does {name} belong to?",
            cry: "Whoose cry is this?",
            playCry: 'Play',
        },
        result: 'You answered {correctAnswers}/{questionsTotal} questions correctly and earned {payout}',
        winNotificaton: "You've earned {payout} credits ",
        nextQuestion: 'Continue to next question',
        finish: 'Show results',
    },
    slot: {
        title: 'Eeveelution Slots',
        bet: 'Bet',
        spin: 'Spin',
        spinning: 'Spinning',
        fastSpin: ' Fast Spin',
        sound: ' Sound',
        lastWin: 'Last Win',
        noCredit: 'Not enough credit',
        win: 'You won {win} credits',
        maxBet: 'Max bet is {max}',
        minBet: 'Min bet is 10.',
    },
    trading: {
        title: 'Trading',
        tabs: {
            inbox: 'Inbox',
            sent: 'Sent',
            new: 'New',
            wishlist: 'Wishlist',
        },
        received: 'Received offers',
        noOffersPending: 'There are currently no pending offers',
        offeredBy: 'Offered by',
        cardName: 'Card name',
        set: 'Set',
        inCollection: 'In your collection',
        youOffered: 'You offered',
        deny: 'Deny',
        answer: 'Answer',
        cancelOffer: 'Cancel offer',
        sentOffers: 'Sent offers',
        noSentOffers: 'You don\'t have any offers sent at the moment',
        offeredTo: 'Offered to',
        theirOffer: 'Their offer',
        makeOffer: 'Make an offer',
        searchUser: 'Search for username',
        offer: 'Offer',
        yourWishlist: 'Your wishlist',
        answerOffer: 'Answer offer',
        makeOfferTo: 'Make an offer to {name}',
        selectCard: 'Select a card you want to offer in exchange to {name}',
        theirWishlist: 'Cards on their wishlist',
        offerCard: 'Offer {card}',
        notifications: {
            denyOfferBy: 'Do you really want to deny this offer by {name}?',
            cancelOfferTo: 'Do you really want to cancel this offer to {name}?',
        }
    },
    social: {
        title: 'Social Feed',
        tabs: {
            following: 'Following',
            global: 'Discover',
            search: 'Search',
        },
        noFollowing: 'You\'re not following anyone yet',
        onlyBoosters: 'Looks like only booster opening posts are available right now in the latest feed!',
        hideBoosters: 'Hide booster openings',
        searchUsers: 'Search for users',
        followers: 'Followers',
        following: 'Following',
        liked: 'Liked posting',
        deleteConfirm: 'Do you want to delete this posting?',
        postingDeleted: 'Posting has been deleted'
    },
    search: {
        title: 'Card search',
        placeholder: 'Search for a Pokémon, Artist or Set',
        highlightOwned: 'Highlight owned cards',
        found: '{results} cards found',
        cutResults: '(results are limited to 300, please refine your search)',
        minLength: 'Search for at least 3 characters',
        noResults: 'No cards found'
    },
    settings: {
        title: 'Settings',
        chooseAvatar: 'Choose your avatar',
        showUnknown: 'Show unkown cards in gallery',
        disableSeasonalDesigns: 'Disable seasonal designs',
        language: 'Language',
        languages: {
            en: 'English',
            de: 'German',
        },
        enablePush: 'Enable push-notifications',
        logout: 'Logout',
        deleteAccount: 'Delete my account',
        notifications: {
            updateAvatar: 'Avatar updated',
            pushEnabled: 'Push notifications enabled',
        }
    },
    wordle: {
        title: 'PokéWordle',
        greeting: 'Welcome to PokéWordle!',
        info: 'Guess the name of a Pokémon and earn credits!',
        selectDifficulty: 'Choose your difficulty',
        letterCount: 'Letters',
        newRound: 'Start',
        invalidSubmission: 'Not a valid Pokémon name',
        incorrect: 'Wrong!',
        correct: 'Correct!',
        solutionWas: 'The solution was "{name}"',
        winNotificaton: "You've earned {payout} credits ",
        possibleEntries: 'Included Pokémon',
    },
    quests: {
        title: 'Today\'s Quests',
        booster_openings: 'zero | Open {n} booster pack | Open {n} booster packs',
        booster_purchases: 'zero | Purchase {n} booster pack | Purchase {n} booster packs',
        card_rarity_pulls: 'Pull {quantity} {rarity} cards',
        card_type_pulls: 'Pull {quantity} {type} cards',
        item_purchases: {
            'booster-box': 'zero | Buy {n} Display | Buy {n} Displays',
            'booster-bundle': 'zero | Buy {n} Booster-Bundle | Buy {n} Booster-Bundles',
            'collection': 'zero | Buy {n} Collection | Buy {n} Collections',
            'duo-blister': 'zero | Buy {n} Duo-Blister | Buy {n} Duo-Blisters',
            'elite-trainer-box': 'zero | Buy {n} Elite-Trainer-Box | Buy {n} Elite-Trainer-Boxes',
            'mini-tin': 'zero | Buy {n} Mini-Tin | Buy {n} Mini-Tins',
            'mixed-blister': 'zero | Buy {n} mixed Blister | Buy {n} mixed Blisters',
            'quad-blister': 'zero | Buy {n} Quad Blister | Buy {n} Quad Blisters',
            'single-blister': 'zero | Buy {n} Single Blister | Buy {n} Single Blisters',
            'single-booster-4': 'zero | Buy {n} single Booster-Pack with 4 cards | Buy {n} single Booster-Packs with 4 cards',
            'single-booster-5': 'zero | Buy {n} single Booster-Pack with 5 cards | Buy {n} single Booster-Packs with 5 cards',
            'single-booster-6': 'zero | Buy {n} single Booster-Pack with 6 cards | Buy {n} single Booster-Packs with 6 cards',
            'single-booster-7': 'zero | Buy {n} single Booster-Pack with 7 cards | Buy {n} single Booster-Packs with 7 cards',
            'triple-blister': 'zero | Buy {n} Triple Blister | Buy {n} Triple Blisters',
        },
        trades_done: 'zero | Complete {n} trade | Complete {n} trades',
        quizzes_done: 'zero | Complete {n} quiz | Complete {n} quizzes',
        wordles_done: 'zero | Solve {n} PokéWordle | Solve {n} PokéWordles',
        collect_success: 'Rewards collected!',
        collect: 'Collect',
        collected: 'Collected',
    }
}
